// ─── Feuille : GROUPE IVV d'un compte ─────────────────────────────
// Un groupe IVV est une IDENTITÉ de valideur partagée par plusieurs comptes
// (mêmes faits techniques, mêmes réponses aux questionnaires). Ici on nomme le
// groupe du compte ; le champ vide le retire du groupe.
import React, { useEffect, useMemo, useState } from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, stylesForm, useUI, useT } from '@mop/core';

export default function FeuilleGroupeIVV({ visible, compte, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [nom, setNom] = useState('');

  useEffect(() => { if (visible) setNom(compte?.groupeIVV || ''); }, [visible, compte]);
  const modifie = nom.trim() !== (compte?.groupeIVV || '');

  return (
    <Feuille visible={visible} titre={t('admin.groupeIVV')} emoji="👥" hauteur={0.4} onFermer={onFermer}
      action={{ icone: '💾', label: t('commun.enregistrer'), disabled: !modifie,
        onPress: () => { onEnregistrer?.(nom.trim()); onFermer?.(); } }}>
      <Text style={s.lbl}>{t('admin.nomGroupe')}</Text>
      <TextInput style={s.input} value={nom} onChangeText={setNom} autoFocus autoCapitalize="words"
        placeholder={t('admin.phNomGroupe')} placeholderTextColor={UI.faint} />
      <Text style={s.aide}>{t('admin.groupeIVVAide')}</Text>
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  aide: { fontSize: 11.5, color: UI.faint, marginTop: 12, lineHeight: 16 },
});
